import axios from 'axios';
import apiConfig from '../api.config';

export default function getAccountFunctionalities({ hotelId }) {
  const {
    host,
    URIs: { accountFunctionalities },
  } = apiConfig;

  const uri = `${host}${accountFunctionalities.replace(':hotelId', hotelId)}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
